module.exports = __webpack_public_path__ + "static/media/1.4bf88d1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/03/projects/01/1.jpg
// module id = 408
// module chunks = 0